if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options.filter(x=>(requiredOptionsSettingUnique.indexOf(x)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && this.getOptionValues(x).length>1);
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      window.rechargePriceSync?.init(this);
    }

    getOptionValues(optionName) {
      if (!this.optionValues[optionName]) {
        function filterUnique(value, index, array) {
          return array.indexOf(value) === index;
        }
        var ix = this.productData.options.indexOf(optionName);
        this.optionValues[optionName] = this.productData.variants.map(v=>v['option'+(1+ix)]).filter(filterUnique);
      }
      return this.optionValues[optionName];
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      if (this.rechargeSellingPlanAllocation) {
        return this.rechargeSellingPlanAllocation;
      }
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      //lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });}
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        if(this.optionsButton.dataset.preselectedVariant){
          this.optionsButton.addEventListener('click', this.addToCart.bind(this));
        }else{
          this.optionsButton.addEventListener('click', this.openOptions.bind(this));
        }
      }

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    addToCart(e) {
      e.preventDefault()
      var btn = this.querySelector('.atc-options-wrapper form .btn.add');
      btn.dispatchEvent(new Event('click', {bubbles: true}));
    }

    openOptions(e) {
      e.preventDefault()
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_image : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      //update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add').style.display = '';
          this.querySelector('.sold-out-message').classList.add('hide');
          if (requiredBtn) requiredBtn.style.display = 'none';
        } else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add').style.display = 'none';
          this.querySelector('.sold-out-message').classList.remove('hide')
          if (requiredBtn) requiredBtn.style.display = 'none';
        }
      });
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
        }
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        var filterSource = media.alt || '';
        if (filterSource.indexOf('|') > -1) {
          var altParts = filterSource.split('|');
          if (altParts.length > 1) {
            filterSource = altParts[1];
          }
        }
        if (filterSource && filterSource != '') {
          var filter = filterSource.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key.trim());
              if(optionIndex>=0 && values) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();
      this.videoAutoplay = this.dataset.videoAutoplay;
      this.autoplayOptionsElement = this.videoAutoplay ? this.querySelector('.autoplay-options') : null;
      this.autoplayCheck = this.autoplayOptionsElement ? this.autoplayOptionsElement.querySelector('input') : null;
      if (this.autoplayCheck) {
        this.autoplayCheck.addEventListener('change', (e)=>{
          Cookies.set('autoplay', e.target.checked ? 'enabled' : 'disabled');
        });
        this.autoplayCheck.checked = Cookies.get('autoplay') !== 'disabled';
      }

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            let canPlay = true;
            if (this.autoplayOptionsElement) {
              this.autoplayOptionsElement.classList.remove('visible');
            }
            if (this.videoAutoplay) {
              const media = keen.currentSlide().querySelector('.media');
              if (this.autoplayOptionsElement && media) { //&& media is to only show the checkbox on video slides.
                this.autoplayOptionsElement.classList.add('visible');
                //TODO eval  checkbox
                this.autoplayCheck.checked = canPlay = Cookies.get('autoplay')!='disabled';
              }
              if (media && canPlay) {
                $s.playMedia(media);
              }
            }
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 5,
          spacing: 5,
          centered: false,
          vertical: this.desktopOrientation=='vertical' ? true : false
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 4.5,
          spacing: 5,
          centered: false,
          vertical: this.desktopOrientation=='vertical' ? true : false
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 7,
          spacing: 5,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 8.5
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity) {
        this.listenEvents.splice(1, 0, 'quantityChange');
      }

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
          if (data && this.finalPriceElement) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
            this.finalPriceElement.innerHTML = $s.formatMoney(data.price * quantity);

            if (data.compare_at_price > data.price && this.comparePriceElement) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(data.compare_at_price * quantity);
              this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(data.price * quantity);
            } else {
              if (this.comparePriceElement) {
                this.comparePriceElement.classList.add('hide');
                this.comparePriceElement.innerHTML = '';
              }
            }
            this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data.price * quantity}}));
          } else if (this.finalPriceElement) {
            this.finalPriceElement.innerHTML = '';
            if (this.comparePriceElement) {
              this.comparePriceElement.innerHTML = '';
            }
          }
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);

      if(this.mainElement.productData.variants.length === 1){
        this.classList.add('single-variant');
        if(this.mainElement.querySelector('.product-variant') != null && this.mainElement.productData.options.length === 1){
          this.mainElement.querySelector('.product-variant').innerHTML = this.mainElement.productData.options[0] + '. ' + this.mainElement.productData.variants[0].title;
        }
      }
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var options = ['option1', 'option2', 'option3'];
          var imgOption = options.splice(this.swatchImg.dataset.option/1 -1 ,1);
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value);
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_image) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = 80;
                img.height = 80;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_image.src, '80x');
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content scheme" style="width: ${infoLink.dataset.width}rem">
                <img alt="" src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();
      this.colorSwatchesOptions = ["Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
      var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
      var html = `
        <div class="option-name">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">${lngg.product_main__select_label} ${this.label} </span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
        <div class="swatch-group flex flex-wrap"></div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
      var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        
        html += `
          <div class="swatch" data-available="${option.available}">
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
            <label for="${id}">
              <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
                <span>${option.value}${soldOut}</span>
              </div>
            </label>
          </div>
        `;
      });
      var group = this.querySelector('.swatch-group');
      group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name" for="${optionId}">
        ${lngg.product_main__select_label} ${this.infoIcon}${this.label} 
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}"></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
      var html = '';
      if (this.required()) {
        html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
      options.forEach((option, index)=>{
        let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
        html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
      });
      var select = this.querySelector('select');
      select.innerHTML = html;

      if(defaultValue) {
        var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
        if(newValueIndex>=0) {
          select.selectedIndex = newValueIndex;
        }
      }
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}



//REF: FEATURE SELLING PLANS — shared subscription label helpers (theme + Recharge widget)
window.subscriptionPlanLabels = window.subscriptionPlanLabels || {
  frequencySaveLabelTpl: "{{ frequency }}: save {{ percent }}%",

  formatFromTemplate: function(frequency, discount) {
    if (discount > 0) {
      return this.frequencySaveLabelTpl
        .replace(/\{\{\s*frequency\s*\}\}/g, frequency)
        .replace(/\{\{\s*percent\s*\}\}/g, String(discount));
    }
    return frequency;
  },

  getFrequencyFromPlanName: function(name) {
    if (!name) {
      return '';
    }
    const options = name.options || [];
    const findOption = function(re) {
      return options.find(function(o) {
        return o && o.name && re.test(String(o.name));
      });
    };
    const deliveryEvery = findOption(/^delivery every$/i) || findOption(/delivery frequency/i);
    const intervalOpt = findOption(/^delivery interval$/i) || findOption(/^interval$/i);
    if (deliveryEvery && intervalOpt) {
      const count = String(deliveryEvery.value);
      let unit = String(intervalOpt.value).toLowerCase().replace(/\(s\)/g, '').replace(/s$/, '');
      return count === '1' ? '1 ' + unit : count + ' ' + unit + 's';
    }
    const planName = (name.name || name).trim();
    const lower = planName.toLowerCase();
    let match = planName.match(/^(\d+\s+(?:week|weeks|month|months|day|days))/i);
    if (match) {
      return match[1].toLowerCase();
    }
    match = planName.match(/deliver(?:y)?\s+every\s+(\d+)\s+(week|month|day)s?/i);
    if (match) {
      const count = match[1];
      const unit = match[2].toLowerCase();
      return count === '1' ? '1 ' + unit : count + ' ' + unit + 's';
    }
    match = planName.match(/(\d+)\s*(week|month|day)s?\s+subscription/i);
    if (match) {
      const count = match[1];
      const unit = match[2].toLowerCase();
      return count === '1' ? '1 ' + unit : count + ' ' + unit + 's';
    }
    const subIdx = lower.indexOf(' subscription');
    if (subIdx > -1) {
      return planName.slice(0, subIdx).trim().toLowerCase();
    }
    const withIdx = lower.indexOf(' with ');
    if (withIdx > -1) {
      return planName.slice(0, withIdx).trim().toLowerCase();
    }
    return planName;
  },

  getDiscountPercent: function(planAlloc, sellingPlan) {
    if (planAlloc && planAlloc.compare_at_price && planAlloc.compare_at_price > planAlloc.price) {
      return Math.round(100 - (planAlloc.price / planAlloc.compare_at_price) * 100);
    }
    const name = (sellingPlan && sellingPlan.name) || (typeof planAlloc === 'string' ? planAlloc : '');
    const pctMatch = String(name).match(/(\d+)\s*%/);
    if (pctMatch) {
      return parseInt(pctMatch[1], 10);
    }
    return 0;
  },

  formatFromPlanName: function(name) {
    const frequency = this.getFrequencyFromPlanName(typeof name === 'string' ? {name: name, options: []} : name);
    const discount = this.getDiscountPercent(null, typeof name === 'string' ? {name: name} : name);
    return this.formatFromTemplate(frequency, discount);
  },

  formatFromAllocation: function(planAlloc, sellingPlan) {
    const frequency = this.getFrequencyFromPlanName(sellingPlan || {name: '', options: []});
    const discount = this.getDiscountPercent(planAlloc, sellingPlan);
    return this.formatFromTemplate(frequency, discount);
  },

  patchTextNode: function(text) {
    const trimmed = (text || '').trim();
    if (!trimmed || !/subscription|%\s*(off|discount)|with\s+\d+\s*%/i.test(trimmed)) {
      return text;
    }
    const formatted = this.formatFromPlanName(trimmed);
    return formatted && formatted !== trimmed ? formatted : text;
  },

  walkShadowRoots: function(node, callback) {
    if (!node) {
      return;
    }
    callback(node);
    if (node.shadowRoot) {
      this.walkShadowRoots(node.shadowRoot, callback);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('*').forEach((child) => {
        if (child.shadowRoot) {
          this.walkShadowRoots(child.shadowRoot, callback);
        }
      });
    }
  },

  patchRechargeWidgets: function() {
    const selectors = '.recharge-subscription-widget, .shopify-app-block[class*="recharge"], [class*="recharge-subscription"], rc-selling-plans, [data-testid="subscription-widget"]';
    document.querySelectorAll(selectors).forEach((widget) => {
      this.walkShadowRoots(widget, (root) => {
        if (!root.querySelectorAll) {
          return;
        }
        root.querySelectorAll('option').forEach((opt) => {
          const next = this.patchTextNode(opt.textContent);
          if (next !== opt.textContent) {
            opt.textContent = next;
          }
        });
        root.querySelectorAll('label, [class*="option"], [class*="frequency"], [class*="selling-plan"]').forEach((el) => {
          if (el.children.length > 0) {
            return;
          }
          const next = this.patchTextNode(el.textContent);
          if (next !== el.textContent) {
            el.textContent = next;
          }
        });
      });
    });
  }
};

(function() {
  var labels = window.subscriptionPlanLabels;
  var debounceTimer;
  function scheduleRechargePatch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      labels.patchRechargeWidgets();
    }, 100);
  }
  document.addEventListener('DOMContentLoaded', scheduleRechargePatch);
  document.addEventListener('shopify:section:load', scheduleRechargePatch);
  new MutationObserver(scheduleRechargePatch).observe(document.documentElement, {childList: true, subtree: true});
})();

if(!customElements.get('product-selling-plan')) {
  class ProductSellingPlan extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.input = this.querySelector('[name="selling_plan"]');
      this.inputFrequencyName = this.querySelector('[name="selling_plan_frequency"]');
      this.groupsContainer = this.querySelector('[data-groups]');
      this.plansContainer = null; //obtained after every group render
      this.textOnetime = this.dataset.textOnetime || "Deliver one-time only";
      this.textSubscribe = this.dataset.textSubscribe || "Subscribe";
      this.textSubscribeSave = this.dataset.textSubscribesave || "Subscribe to Save";
      this.combineGroups = true;
      this.rechargePlansOnly = true;
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false
      this.mainElement.lastSelectedSellingPlanId = this.input.value || this.getFirstDisplayedSellingPlanId();

      this.input.addEventListener('change', ()=>{
        this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
      });

      this.addEventListener('click', (e) => {
        if (!this.groupsContainer) {
          return;
        }
        const oneTimeRadio = this.groupsContainer.querySelector('[name="purchase_option"][value=""]');
        const isOneTime = oneTimeRadio && oneTimeRadio.checked;

        const chevron = e.target.closest('label.field-select-chevron');
        if (chevron) {
          const forId = chevron.getAttribute('for');
          const planSelect = forId ? document.getElementById(forId) : null;
          if (!planSelect || planSelect.tagName !== 'SELECT') {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          if (isOneTime) {
            this.selectSubscribeAndOpenSelect(planSelect);
            return;
          }
          if (planSelect.disabled) {
            return;
          }
          this.openPlanSelectPicker(planSelect);
          return;
        }

        if (isOneTime && e.target.closest('[data-plans] .field') && e.target.closest('[data-plans]') && this.contains(e.target)) {
          const field = e.target.closest('[data-plans] .field');
          const planSelect = field && field.querySelector('select');
          if (planSelect) {
            e.preventDefault();
            e.stopPropagation();
            this.selectSubscribeAndOpenSelect(planSelect);
          }
        }
      }, true);

      this.listenEvents = ['variantChange'];
      if (this.multiplyQuantity)
        this.listenEvents.push('quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          this.groupsContainer.innerHTML = this.getGroupsHtml();
          let {sellingPlan, group} = this.getSellingPlanByIdWithGroup(this.input.value);
          if (!sellingPlan && this.input.value) {
            const groups = this.getSellingPlanGroups();
            group = groups[0] || null;
            sellingPlan = group && group.selling_plans ? group.selling_plans[0] : null;
          }
          const groupId = group ? this.getHandledGroupId(group.id) : '';
          let currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"][value="'+groupId+'"]');
          if (!currentGroupInput) {
            currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"][value=""]');
          }
          if (!currentGroupInput) {
            //default to another group or even the One Time purchase if this variant doesn't have Selling Plans available
            currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"]:not([value=""])') || this.groupsContainer.querySelector('[name="purchase_option"]');
          }
          let currentPlanSelect = currentGroupInput.closest('div').querySelector('select');

          const groupInputs = this.groupsContainer.querySelectorAll('[name="purchase_option"]');
          groupInputs.forEach(groupInput=>{
            const planSelect = groupInput.closest('div').querySelector('select');
            groupInput.addEventListener('change', (e)=>{
              this.updateSellingPlan(planSelect ? planSelect.value : '');
            })
            if (planSelect) {
              planSelect.addEventListener('change', (e)=>{
                // switching frequency should also switch purchase option UI to subscription
                groupInput.checked = true;
                this.updateSellingPlan(e.target.value);
              });
            }
          })

          currentGroupInput.checked = true;
          if (currentPlanSelect) {
            for (let i = 0; i < currentPlanSelect.options.length; i++) {
              const option = currentPlanSelect.options[i];
              if (sellingPlan && (option.text == sellingPlan.name || option.value==sellingPlan.id)) {
                currentPlanSelect.selectedIndex = i;
              }
            }
          }
          this.updateSellingPlan(currentPlanSelect ? currentPlanSelect.value : '');
          this.showSellingPlanDetails();
          this.refreshFrequencyOptionLabels();
        });
      });

      var selfSellingPlan = this;
      setTimeout(function() {
        selfSellingPlan.refreshFrequencyOptionLabels();
        selfSellingPlan.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: selfSellingPlan.getCurrentPlan()}}));
      }, 100);

    }

    getSellingPlanGroups() {
      const allGroups = this.mainElement.productData?.sellingPlanGroups || [];
      if (this.rechargePlansOnly) {
        return allGroups.filter((group) => this.isRechargeSellingPlanGroup(group));
      }
      return allGroups;
    }

    isRechargeSellingPlanGroup(group) {
      if (!group) {
        return false;
      }
      const rawAppId = group.app_id != null ? group.app_id : group.appId;
      if (rawAppId != null && String(rawAppId) === '294517') {
        return true;
      }
      return !!(group.selling_plans && group.selling_plans.some((plan) => plan.options && plan.options.some((opt) => opt.name === 'Recharge Plan ID')));
    }

    groupForAllocation(planAlloc) {
      return this.mainElement.productData.sellingPlanGroups.find((x) => x.id == planAlloc.selling_plan_group_id);
    }

    getVariantAllocationsForDisplay(currentVariant) {
      if (!currentVariant || !currentVariant.selling_plan_allocations) {
        return [];
      }
      if (!this.rechargePlansOnly) {
        return currentVariant.selling_plan_allocations;
      }
      return currentVariant.selling_plan_allocations.filter((planAlloc) => this.isRechargeSellingPlanGroup(this.groupForAllocation(planAlloc)));
    }

    getFirstDisplayedSellingPlanId() {
      const variant = this.mainElement.getCurrentVariant && this.mainElement.getCurrentVariant();
      if (variant) {
        const displayed = this.getVariantAllocationsForDisplay(variant);
        if (displayed[0]) {
          return displayed[0].selling_plan_id;
        }
      }
      const groups = this.getSellingPlanGroups();
      const firstGroup = groups[0];
      return firstGroup && firstGroup.selling_plans && firstGroup.selling_plans[0] && firstGroup.selling_plans[0].id;
    }

    getSellingPlanByIdWithGroup(id) {
      const groups = this.getSellingPlanGroups();
      for (let i=0; id && i < groups.length; i++) {
        const group = groups[i];
        const sellingPlan = group.selling_plans.find(x=>x.id==id)
        if (sellingPlan) {
          return {sellingPlan, group}
        }
      }
      return {sellingPlan: null, group: null};
    }

    getHandledGroupId(groupId) {
      return this.combineGroups ? 'subscribe' : groupId;
    }

    formatPlanOptionLabel(planAlloc) {
      const lookup = this.getSellingPlanByIdWithGroup(planAlloc.selling_plan_id);
      return window.subscriptionPlanLabels.formatFromAllocation(planAlloc, lookup.sellingPlan);
    }

    refreshFrequencyOptionLabels() {
      if (!this.groupsContainer) {
        return;
      }
      const self = this;
      const currentVariant = this.mainElement.getCurrentVariant();
      if (!currentVariant || !currentVariant.selling_plan_allocations) {
        return;
      }
      this.groupsContainer.querySelectorAll('[data-plans] select option').forEach(function(opt) {
        const planAlloc = currentVariant.selling_plan_allocations.find(function(x) {
          return String(x.selling_plan_id) === String(opt.value);
        });
        if (planAlloc) {
          opt.textContent = self.formatPlanOptionLabel(planAlloc);
        }
      });
      this.groupsContainer.querySelectorAll('.selling-plan-name').forEach(function(el) {
        const select = el.closest('[data-plans]') && el.closest('[data-plans]').querySelector('select');
        if (select && select.options[select.selectedIndex]) {
          const planAlloc = currentVariant.selling_plan_allocations.find(function(x) {
            return String(x.selling_plan_id) === String(select.value);
          });
          if (planAlloc) {
            el.textContent = self.formatPlanOptionLabel(planAlloc);
          }
        }
      });
    }

    showSellingPlanDetails() {
      const currentVariant = this.mainElement.getCurrentVariant();
      const groupLabels = this.groupsContainer.querySelectorAll('[name="purchase_option"]:not([value=""]) + label');
      groupLabels.forEach(label=>{
        const planSelect = label.closest('div').querySelector('select');
        const planAlloc = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==planSelect.value);
        const quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        const discount = planAlloc.compare_at_price && planAlloc.compare_at_price > planAlloc.price ? Math.round(100 - planAlloc.price/planAlloc.compare_at_price*100) : 0;
        const optionPrice = $s.formatMoney(planAlloc.price * quantity);
        label.innerHTML = `<div>` + (discount ? this.textSubscribeSave + ' <span class="option-discount">'+discount+'%</span>' : this.textSubscribe) + ` <span class="option-price"> - ${optionPrice}</span></div>`;

      });
      return;
    }

    openPlanSelectPicker(planSelect) {
      if (typeof planSelect.showPicker === 'function') {
        try {
          planSelect.showPicker();
          return;
        } catch (err) {
          /* continue to focus fallback */
        }
      }
      planSelect.focus();
      planSelect.dispatchEvent(new MouseEvent('mousedown', {bubbles: true, cancelable: true, view: window, buttons: 1}));
      planSelect.dispatchEvent(new MouseEvent('mouseup', {bubbles: true, cancelable: true, view: window, buttons: 1}));
      planSelect.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window, buttons: 1}));
    }

    selectSubscribeAndOpenSelect(planSelect) {
      if (!this.groupsContainer || !planSelect) {
        return;
      }
      const plansBlock = planSelect.closest('[data-plans]');
      if (!plansBlock) {
        return;
      }
      const row = plansBlock.parentElement;
      if (!row) {
        return;
      }
      const subscribeRadio = row.querySelector('input[name="purchase_option"]:not([value=""])');
      if (!subscribeRadio) {
        return;
      }
      subscribeRadio.checked = true;
      subscribeRadio.dispatchEvent(new Event('change', {bubbles: true}));
      const self = this;
      const sel = planSelect;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (self.groupsContainer && sel && !sel.disabled) {
            self.openPlanSelectPicker(sel);
          }
        });
      });
    }

    syncFrequencySelectsEnabledState() {
      if (!this.groupsContainer) {
        return;
      }
      const oneTimeRadio = this.groupsContainer.querySelector('[name="purchase_option"][value=""]');
      const isOneTimeSelected = oneTimeRadio && oneTimeRadio.checked;
      this.groupsContainer.querySelectorAll('[data-plans] select').forEach((planSelect) => {
        planSelect.disabled = isOneTimeSelected;
      });
    }

    updateSellingPlan(sellingPlanId) {
      this.input.value = sellingPlanId;
      if (sellingPlanId) {
        this.mainElement.lastSelectedSellingPlanId = sellingPlanId;
        const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(sellingPlanId);
        const currentVariant = this.mainElement.getCurrentVariant();
        const planAlloc = currentVariant && currentVariant.selling_plan_allocations.find(function(x) {
          return String(x.selling_plan_id) === String(sellingPlanId);
        });
        this.inputFrequencyName.value = planAlloc ? this.formatPlanOptionLabel(planAlloc) : (sellingPlan ? sellingPlan.name : '');
      } else {
        this.inputFrequencyName.value = '';
      }
      this.showSellingPlanDetails();
      this.syncFrequencySelectsEnabledState();
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
    }

    getGroupsHtml() {
      var showFrequency = true;
      var currentVariant = this.mainElement.getCurrentVariant();
      var html = '';
      var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
      const sellingPlanGroups = this.getSellingPlanGroups();
      const allowedGroupIds = {};
      sellingPlanGroups.forEach((g) => {
        if (g && typeof g.id !== 'undefined') {
          allowedGroupIds[String(g.id)] = true;
        }
      });

      if(!this.mainElement.productData.requiresSellingPlan) {
        let optionId = `plan-option-onetime-${this.mainElement.sectionId}`;
        let optionPrice = $s.formatMoney(currentVariant.price * quantity);
        html += `
          <div>
            <input class="radio-custom" type="radio" name="purchase_option" value="" id="${optionId}">
            <label class="radio-custom-label" for="${optionId}"><div>${this.textOnetime} <span class="option-price"> - ${optionPrice}</span></div></label>
          </div>
        `;
      }
      if(currentVariant) {
        const displayedAllocations = this.getVariantAllocationsForDisplay(currentVariant);
        displayedAllocations.forEach((planAlloc, ix)=>{
          if (this.combineGroups && ix>0) {
            return;
          }
          if (!allowedGroupIds[String(planAlloc.selling_plan_group_id)]) {
            return;
          }
          const group = sellingPlanGroups.find(x=>x.id==planAlloc.selling_plan_group_id);
          if (!group) {
            //current variant doesn't support this selling plan group;
            return;
          }

          const groupId = this.getHandledGroupId(group.id);
          let optionId = `plan-option-${groupId}-${this.mainElement.sectionId}`;
          html += `
            <div>
              <input class="radio-custom" type="radio" name="purchase_option" value="${groupId}" id="${optionId}">
              <label class="radio-custom-label" for="${optionId}">Subscribe</label>
              <div data-plans class="${!showFrequency ? 'frequency-hidden': ''}">${this.getPlansHtml(group)}</div>
            </div>
          `;
        });
      }
      return html;
    }

    getPlansHtml(group) {
      //functionalities:
      // show or hide frequency dropdown when the One-Time option is selected
      // show a div with the frequency option when there is a single option but keep the <select> hidden
      //
      var currentVariant = this.mainElement.getCurrentVariant();
      var enabled = this.input.value!='';

      var html = '';
      const displayedAllocations = this.getVariantAllocationsForDisplay(currentVariant);
      const groupPlanAllocations = this.combineGroups ? displayedAllocations : displayedAllocations.filter(x=>x.selling_plan_group_id==group.id);
      var isOneOption = groupPlanAllocations.length==1;
      html = `<div class="field no-label ${isOneOption ? 'hide' : ''}"><select id="frequency-${currentVariant.id}" class="${enabled ? 'enabled' : ''}" ${enabled ? '' : 'disabled="disabled"'}>`;
      groupPlanAllocations.forEach((plan)=>{
        const {sellingPlan} = this.getSellingPlanByIdWithGroup(plan.selling_plan_id);
        if (!sellingPlan) {
          return;
        }
        html += `<option value="${sellingPlan.id}">${this.formatPlanOptionLabel(plan)}</option>`;
      });
      html += `</select><label for="frequency-${currentVariant.id}" class="field-select-chevron"><svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"></path></svg></label></div>`;
      if (isOneOption && groupPlanAllocations[0]) {
        html += `<div class="selling-plan-name">${this.formatPlanOptionLabel(groupPlanAllocations[0])}</div>`;
      }

      return html;
    }

    getCurrentPlan() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if (currentVariant && this.input.value) {
        return currentVariant.selling_plan_allocations.find(function(x) {
          return String(x.selling_plan_id) === String(this.input.value);
        }.bind(this));
      }
      return false;
    }

  }
  customElements.define('product-selling-plan', ProductSellingPlan);
}


window.rechargePriceSync = window.rechargePriceSync || {
  walkShadowRoots: function(node, callback) {
    if (!node) {
      return;
    }
    callback(node);
    if (node.shadowRoot) {
      this.walkShadowRoots(node.shadowRoot, callback);
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('*').forEach((child) => {
        if (child.shadowRoot) {
          this.walkShadowRoots(child.shadowRoot, callback);
        }
      });
    }
  },

  hasPart: function(element, partName) {
    return (element.getAttribute('part') || '').split(/\s+/).includes(partName);
  },

  findPartUnder: function(node, partName) {
    var found = null;
    this.walkShadowRoots(node, function(root) {
      if (!root.querySelectorAll || found) {
        return;
      }
      root.querySelectorAll('[part]').forEach(function(el) {
        if (!found && rechargePriceSync.hasPart(el, partName)) {
          found = el;
        }
      });
    });
    return found;
  },

  getSelectedPurchaseOption: function(widget) {
    var selected = null;
    this.walkShadowRoots(widget, function(root) {
      if (!root.querySelectorAll) {
        return;
      }
      root.querySelectorAll('[part]').forEach(function(el) {
        if (rechargePriceSync.hasPart(el, 'rc-purchase-option__selected') || rechargePriceSync.hasPart(el, 'rc-quantity-upsell-option__selected')) {
          selected = el;
        }
      });
    });
    return selected;
  },

  parseMoneyToCents: function(text) {
    if (!text) {
      return null;
    }
    var cleaned = String(text).replace(/[^\d.,]/g, '').replace(/,/g, '');
    if (!cleaned) {
      return null;
    }
    var parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1];
    }
    var amount = parseFloat(cleaned);
    if (isNaN(amount)) {
      return null;
    }
    return Math.round(amount * 100);
  },

  getSellingPlanIdFromForm: function(mainElement) {
    var form = mainElement.querySelector('form[action*="/cart/add"]');
    if (!form) {
      return '';
    }
    var input = form.querySelector('[name="selling_plan"]');
    return input && input.value ? String(input.value) : '';
  },

  getPlanAllocation: function(mainElement, sellingPlanId) {
    var variant = mainElement.getCurrentVariant();
    if (!variant || !variant.selling_plan_allocations || !sellingPlanId) {
      return null;
    }
    return variant.selling_plan_allocations.find(function(x) {
      return String(x.selling_plan_id) === String(sellingPlanId);
    }) || null;
  },

  buildAllocationFromWidget: function(mainElement, selectedOption) {
    var variant = mainElement.getCurrentVariant();
    if (!variant || !selectedOption) {
      return null;
    }

    var isSubscription = this.hasPart(selectedOption, 'rc-purchase-option__subscription') || this.hasPart(selectedOption, 'rc-quantity-upsell-option__selected');
    if (!isSubscription) {
      return null;
    }

    var discountedEl = this.findPartUnder(selectedOption, 'rc-purchase-option__discounted-price');
    var unitEl = this.findPartUnder(selectedOption, 'rc-purchase-option__unit-price');
    var priceEl = this.findPartUnder(selectedOption, 'rc-purchase-option__price');
    var originalEl = this.findPartUnder(selectedOption, 'rc-purchase-option__original-price');
    var finalCents = this.parseMoneyToCents((discountedEl || unitEl || priceEl || {}).textContent);
    if (!finalCents) {
      return null;
    }

    var compareCents = this.parseMoneyToCents((originalEl || {}).textContent) || variant.price;
    if (variant.compare_at_price > variant.price) {
      compareCents = Math.max(compareCents, variant.compare_at_price);
    }

    return {
      price: finalCents,
      compare_at_price: compareCents > finalCents ? compareCents : variant.price
    };
  },

  applyAllocation: function(mainElement, allocation) {
    var nextAllocation = allocation || null;
    var prevAllocation = mainElement.rechargeSellingPlanAllocation || null;
    var prevPrice = prevAllocation ? prevAllocation.price : null;
    var prevCompare = prevAllocation ? prevAllocation.compare_at_price : null;
    var nextPrice = nextAllocation ? nextAllocation.price : null;
    var nextCompare = nextAllocation ? nextAllocation.compare_at_price : null;

    if (prevPrice === nextPrice && prevCompare === nextCompare) {
      return;
    }

    mainElement.rechargeSellingPlanAllocation = nextAllocation;
    mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: nextAllocation || false}}));
  },

  syncProductMain: function(mainElement) {
    if (!mainElement.querySelector('recharge-subscription-widget, .recharge-subscription-widget')) {
      if (mainElement.rechargeSellingPlanAllocation) {
        mainElement.rechargeSellingPlanAllocation = null;
        mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: false}}));
      }
      return;
    }

    var sellingPlanId = this.getSellingPlanIdFromForm(mainElement);
    var allocation = this.getPlanAllocation(mainElement, sellingPlanId);
    if (!allocation) {
      var selectedOption = this.getSelectedPurchaseOption(mainElement.querySelector('recharge-subscription-widget, .recharge-subscription-widget'));
      allocation = selectedOption ? this.buildAllocationFromWidget(mainElement, selectedOption) : null;
    }

    this.applyAllocation(mainElement, allocation);
  },

  scheduleSync: function(mainElement) {
    clearTimeout(mainElement._rechargePriceSyncTimer);
    mainElement._rechargePriceSyncTimer = setTimeout(function() {
      rechargePriceSync.syncProductMain(mainElement);
    }, 50);
  },

  observeRoot: function(mainElement, root) {
    if (!root || root._rechargePriceSyncObserved) {
      return;
    }
    root._rechargePriceSyncObserved = true;
    new MutationObserver(function() {
      rechargePriceSync.scheduleSync(mainElement);
    }).observe(root, {childList: true, subtree: true, attributes: true, characterData: true});
  },

  init: function(mainElement) {
    if (!mainElement || mainElement.dataset.rechargePriceSyncInit === 'true') {
      return;
    }
    mainElement.dataset.rechargePriceSyncInit = 'true';

    var widget = mainElement.querySelector('recharge-subscription-widget, .recharge-subscription-widget');
    if (!widget) {
      return;
    }

    var sync = this.syncProductMain.bind(this, mainElement);
    mainElement.addEventListener('variantChange', sync);
    widget.addEventListener('click', function() {
      rechargePriceSync.scheduleSync(mainElement);
    });
    widget.addEventListener('change', sync);

    this.observeRoot(mainElement, widget);
    if (widget.shadowRoot) {
      this.observeRoot(mainElement, widget.shadowRoot);
    }

    var form = mainElement.querySelector('form[action*="/cart/add"]');
    if (form) {
      this.observeRoot(mainElement, form);
      form.addEventListener('change', function(e) {
        if (e.target && e.target.name === 'selling_plan') {
          sync();
        }
      });
    }

    sync();
    setTimeout(sync, 500);
    setTimeout(sync, 1500);
  }
};

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('product-main').forEach(function(mainElement) {
    rechargePriceSync.init(mainElement);
  });
});
document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('product-main').forEach(function(mainElement) {
    rechargePriceSync.init(mainElement);
  });
});